if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')){
        if(this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      
      // Initialize customization removal logic
      this.setupCustomizationRemovalLogic();
    }

    setupCustomizationRemovalLogic() {
      let isProcessing = false;
      let processedKeys = new Set(); // Track processed items
      
      document.addEventListener('click', function(e) {
        const removeButton = e.target.closest('cart-remove-button');
        if (!removeButton || isProcessing) return;
        
        isProcessing = true;
        setTimeout(() => { 
          isProcessing = false; 
          processedKeys.clear(); // Clear after processing
        }, 1000);
        
        const line = removeButton.dataset.index;
        const $row = $(`#CartDrawer-Item-${line}, #CartItem-${line}`);
        
        if ($row.length === 0) return;
        
        // Check if this row has Personalisation Text 1
        const hasPersonalisation = $row.find('.product-option dt:contains("Personalisation Text 1")').length > 0;
        
        if (!hasPersonalisation) return;
        
        // Check if this is the customisation product itself
        if ($row.hasClass('customisation-product')) return;
        
        // Get personalisation text value to match with customisation
        const personalisationValue = $row.find('.product-option dt:contains("Personalisation Text 1")').next('dd').text().trim();
        
        if (!personalisationValue) return;
        
        // Find and remove only matching customisation products
        let found = false;
        $('.cart-item.customisation-product').each(function() {
          if (found) return; // Only remove the first match
          
          const $customRow = $(this);
          const customPersonalisation = $customRow.find('.product-option dt:contains("Personalisation Text 1")').next('dd').text().trim();
          
          // Match by personalisation text OR if customisation has no personalisation text (fallback)
          if (customPersonalisation === personalisationValue || !customPersonalisation) {
            const customPropKey = $customRow.attr('prop-key');
            
            if (customPropKey && !processedKeys.has(customPropKey)) {
              found = true;
              processedKeys.add(customPropKey);
              
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: customPropKey,
                  quantity: 0
                })
              })
              .catch(() => {
                // Silently handle errors
              });
            }
          }
        });
      }, true);
    }

    onSubmitHandler(evt) {
      var findCustomisation = this.form.querySelector('.customisation-block');
      var custom_block = $('.customisation-block input[name="properties[Personalisation Text 1]"]');
      var proceed = false;
      var currentTimestamp = null;
      
      if(custom_block.length){
        if(($('.customisation-block input[name="properties[Personalisation Text 1]"]').val().trim().length > 0 ) && findCustomisation ){
            var proceed = true;
            currentTimestamp = Date.now().toString();
            $('.product').attr('timeStamp', currentTimestamp);
        }else{
          var proceed = false; 
        }
      }
      if($('.product').attr('timeStamp') && $('.customisation-block input[name="properties[Personalisation Text 1]"]').length > 0){
        if(($('.product').attr('timeStamp').trim().length > 0) && $('.customisation-block input[name="properties[Personalisation Text 1]"]').val().trim().length > 0){
            var hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'properties[__timestamp]';
            hiddenInput.value = $('.product').attr('timeStamp');
            this.form.appendChild(hiddenInput);
        }
      }
      
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {       
            proceed = false;
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          $(".custom-quick-add li.active").removeClass("active");
          $(".custom-quick-add").removeClass("loader-active");
          $(".custom-quick-add.multiple-op li").removeClass("product-unavailable");
          $(".custom-quick-add.multiple-op li").removeClass("product-available");
          $(".grid__item.size-active").removeClass("size-active");
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if(proceed && currentTimestamp){
            setTimeout(() => {
              const customForm = $('.add-customisation-product form');
              
              if(customForm.length) {
                customForm.find('input[name="properties[__timestamp]"]').remove();
                
                const timestampInput = document.createElement('input');
                timestampInput.type = 'hidden';
                timestampInput.name = 'properties[__timestamp]';
                timestampInput.value = currentTimestamp;
                customForm.append(timestampInput);
              }
              
              const addButton = $('.add-customisation-product button[name="add"]');
              
              if(addButton.length) {
                addButton.click();
              }
            }, 100);
          }
          
          $('.product').attr('timeStamp','');
          $('input[name="properties[__timestamp]"]').remove();
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}